const LISTEN_TAG = 'dn-store';

let $seg;



export default {
  namespaced: true,

  state: {
    category: null,
    id      : null,
    label   : null,
  },

  getters: {
    category: state => state.category,
    id: state => state.id,
    label: state => state.label,
    ready: state => !!state.id,
  },

  actions: {
    init({commit, dispatch, rootGetters}) {
      $seg = window.bcBanner.segments;

      // DN側のマナビジョンページでは属性未設定の場合は「受験生（2）」をデフォルト値として設定する
      // @see: https://jcomintra.backlog.jp/view/BENE_IMJ_CENTER_TEST_2018-252#comment-1183840434
      if (rootGetters['config/isManabi']) {
        $seg.userType.set('2');
      }

      commit('restore');
      dispatch('startWatch');
    },

    startWatch({commit, dispatch}) {
      let firstWatched = false;
      $seg.userType.listen(e => {
        commit('restore');

        if (!firstWatched) {
          firstWatched = true;
        } else {

          // 変更があったのでGAに通知する
          dispatch('sendIdForGa');
        }
      }, LISTEN_TAG);
    },

    setId({commit}, id) {
      commit('setId', id);
    },

    sendIdForGa({state}) {
      const label = state.label;
      if (dn && dn.ga && dn.ga.send) {
        return dn.ga.send({
          category: 'ユーザー属性',
          action  : '登録',
          label,
        });
      }
    },
  },

  mutations: {
    restore: state => {
      const data = $seg.userType.get();
      if (data) {
        state.category = data.category;
        state.id       = data.id;
        state.label    = data.label;
      }
    },

    setId: (state, id) => {
      $seg.userType.set(id);
    },
  },
}


// WEBPACK FOOTER //
// ./src/js/store/modules/segments/modules/user.js